module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_9_B-be82357c3eeed75cb89b141c6600f487.gif";